export function createRequest(dispatch:any) {
  const canceledAmount = dispatch.dispatchItems.canceledAmount ?
    dispatch.dispatchItems.canceledAmount : 0;
  return {
    deliveryDate: dispatch.deliveryDate ? dispatch.deliveryDate : '',
    saleDate: dispatch.saleDate ? dispatch.saleDate : '',
    dispatchNumber: dispatch.dispatchId ? dispatch.dispatchId : '',
    customerDocumentNumber: dispatch.customerDocumentNumber ? dispatch.customerDocumentNumber : '',
    customer: dispatch.customer ? dispatch.customer : '',
    withdrawPerson: dispatch.withdrawPerson ? dispatch.withdrawPerson : '',
    withdrawPersonDoc: dispatch.withdrawPersonDoc ? dispatch.withdrawPersonDoc : '',
    address: dispatch.address ? dispatch.address : '-',
    deliveryTypeCode: dispatch.deliveryTypeCode,
    customerTelephoneContact: dispatch.customerTelephoneContact ? dispatch.customerTelephoneContact : '',
    routeDetail: dispatch.route ? dispatch.route : '',
    saleNoteId: dispatch.saleNoteId,
    itemList: [
      {
        dispatchNumber: dispatch.dispatchId ? dispatch.dispatchId : '',
        skuCode: dispatch.dispatchItems.skuCode ? dispatch.dispatchItems.skuCode : '',
        eanCode: dispatch.dispatchItems.eanCode ? dispatch.dispatchItems.eanCode : '',
        skuName: dispatch.dispatchItems.skuName ? dispatch.dispatchItems.skuName : '',
        amount: dispatch.dispatchItems.pendingAmount ? dispatch.dispatchItems.pendingAmount - canceledAmount : ''
      }
    ]
  };
}
